import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { Paths } from "../../../paths";

export const animalBreadFarmTypeApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getAnimalBreedFarmTypeList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.animalbreedfarmtypes }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getAnimalBreedFarmTypeById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.animalbreedfarmtypes }/${ id }`,
		method: 'GET'
	  })
	}),
	addAnimalBreedFarmType: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.animalbreedfarmtypes }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editAnimalBreedFarmType: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.animalbreedfarmtypes }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteAnimalBreedFarmType: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.animalbreedfarmtypes }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddAnimalBreedFarmTypeMutation,
  useDeleteAnimalBreedFarmTypeMutation,
  useEditAnimalBreedFarmTypeMutation,
  useLazyGetAnimalBreedFarmTypeListQuery
} = animalBreadFarmTypeApi;
